<template>
  <!-- 商品订单 -->
  <div class="index-container">
    <bannerImg bannerText="商品订单" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="r-title">商品订单</div>
        <div class="type-tab-box">
          <div
            class="type-list"
            :class="typeActive === index ? 'type-active' : ''"
            v-for="(item, index) in typeList"
            :key="'type' + index"
            @click="typeSelect(item, index)"
          >{{ item.title }}</div>
        </div>
        <div class="course-box">
          <div class="course-list" v-for="(item, index) in courseList" :key="'course' + index">
            <div class="first-box">
              订单编号：{{ item.order_sn }}
              <span>下单时间：{{ item.create_time }}</span>
              <span
                class="type-text"
                :class="
                  item.order_state === 4 || item.order_state === 5
                    ? 'no-start'
                    : item.order_state === 0
                    ? 'y-text'
                    : ''
                "
              >{{ item.order_state_txt }}</span>
            </div>
            <div class="second-box" v-for="(ele,idx) in item.goods" :key="'goods' + idx">
              <div
                class="c-img"
                @click="goDetail(item)"
                :style="{ backgroundImage: 'url( ' + imgUrl +  ele['thumb']+ ')' }"
              ></div>
              <div class="right-box">
                <div class="c-title">{{ ele.goods_name }}</div>
                <div class="middle-box">
                  <div class="m-text">
                    规格：
                    <span>全集</span>
                  </div>
                  <div class>
                    <div class="text-price">
                      共
                      <span>{{ item.order_num }}</span>件商品 &nbsp;&nbsp;&nbsp;总价：
                      <span>¥{{ ele.sg_price }}</span>&nbsp;&nbsp;&nbsp;实付款：
                      <span class="price">
                        ¥
                        <span>{{ item.order_amount }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="btn-box">
                  <div
                    class="btn yellow-btn"
                    @click.stop="evaluateOrder(item)"
                    v-if="item.order_state === 3"
                  >立即评价</div>
                  <div
                    class="btn yellow-btn"
                    v-if="item.order_state === 2"
                    @click.stop="commonAction('是否确认收货',item)"
                  >确认收货</div>
                  <div
                    class="btn no-btn"
                    v-if="item.order_state === 1 || item.order_state === 0"
                    @click.stop="commonAction('订单取消原因',item)"
                  >取消订单</div>
                  <div
                    class="btn"
                    @click="commonAction('申请开发票',item)"
                    v-if="item.order_state !== 0 && item.order_state_txt !== '已取消'"
                  >申请开票</div>
                  <div
                    class="btn yellow-btn"
                    v-if="item.order_state === 4 || item.order_state === 5"
                  >处理情况</div>
                  <div
                    class="btn"
                    @click.stop="goDetail(item)"
                    v-if="item.order_state === 2 || item.order_state === 3"
                  >查看物流</div>
                  <div
                    class="btn pay-btn"
                    @click.stop="goPay(item)"
                    v-if="item.order_state === 0"
                  >立即付款</div>
                  <div class="btn" @click="commonAction('联系客服',item)">联系客服</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page_index"
          background
          layout="prev, pager, next"
          :page-size="page_size"
          :total="listTotal"
        ></el-pagination>
      </div>
    </personalSidebar>
    <el-dialog :visible.sync="dialogVisible" width="580PX" :close-on-click-modal="false">
      <div class="dialog-title">{{ dialogText }}</div>
      <template v-if="dialogText === '订单取消原因'">
        <div class="select-list">
          <el-radio v-model="reason" label="排错/多拍了">排错/多拍了</el-radio>
        </div>
        <div class="select-list">
          <el-radio v-model="reason" label="地址填错了">地址填错了</el-radio>
        </div>
        <div class="select-list">
          <el-radio v-model="reason" label="不想要了">不想要了</el-radio>
        </div>
        <div class="select-list">
          <el-radio v-model="reason" label="其他">其他</el-radio>
        </div>
        <div class="dialog-btn-box">
          <!-- <div class="btn" @click="goPay1">去支付</div> -->
          <div class="btn cancel" @click="confirmCancelOrder">取消订单</div>
        </div>
      </template>
      <template v-if="dialogText === '是否确认收货'">
        <div class="confirm-button" @click="confirmConfirm">确认收货</div>
      </template>
      <template v-if="dialogText === '申请开发票'">
        <div class="select-box">
          <div class="select-list">
            <el-radio v-model="billInfo.ticket_type" label="个人">个人</el-radio>
          </div>
          <div class="select-list">
            <el-radio v-model="billInfo.ticket_type" label="企业">企业</el-radio>
          </div>
          <div class="select-list">
            <el-radio v-model="billInfo.ticket_real_type" label="普通发票">普通发票</el-radio>
          </div>
          <div class="select-list">
            <el-radio v-model="billInfo.ticket_real_type" label="增值税发票">增值税发票</el-radio>
          </div>
        </div>
        <div class="input-box">
          <div>纳税人抬头</div>
          <el-input v-model="billInfo.ticket_head"></el-input>
        </div>
        <div class="input-box second-input">
          <div>纳税人识别号</div>
          <el-input v-model="billInfo.ticket_no"></el-input>
        </div>
        <div class="confirm-button" @click="applyBill">确认开票</div>
      </template>
      <template v-if="dialogText === '联系客服'">
        <div class="result-box">
          <div>0755-9823654</div>
        </div>
      </template>
      <template v-if="resultTip">
        <div class="result-box">
          <i class="iconfont el-icon-success"></i>
          <div>提交成功</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'commodityOrder',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      imgUrl: imgUrl,
      typeList: [
        {
          title: '全部订单',
          id: ''
        },
        {
          title: '待付款',
          id: 0
        },
        {
          title: '待发货',
          id: 1
        },
        {
          title: '待收货',
          id: 2
        },
        {
          title: '待评价',
          id: 3
        },
        {
          title: '已完成',
          id: 4
        },
        {
          title: '售后退款',
          id: 5
        }
      ],
      typeActive: 0,
      courseList: [],
      listTotal: 0,
      reason: '',
      dialogVisible: false,
      dialogText: '',
      resultTip: false,
      page_index: 1,
      page_size: 6,
      order_state: '',
      order_sn: '',
      billInfo: {
        ticket_head: '',
        ticket_no: '',
        ticket_type: '',
        ticket_real_type: ''
      }
    };
  },
  created() {
    this.getOrderList();
  },
  
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    goPay1() {
      this.$router.push({
        path: 'shoppingPay',
        query: { order_sn: this.order_sn }
      });
    },
    // 立即付款
    goPay(item) {
      this.$router.push({
        path: 'shoppingPay',
        query: { order_sn: item.order_sn }
      });
    },
    // 获取订单列表
    getOrderList() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        order_state: this.order_state
      };
      api.getOrderList(params).then(res => {
        if (res.result) {
          this.courseList = res.result.data;
          this.listTotal = res.result.total;
        }
      });
    },
    typeSelect(item, index) {
      this.page_index = 1;
      this.typeActive = index;
      this.order_state = item.id;
      this.getOrderList();
    },
    // 订单详情
    goDetail(item) {
      this.$router.push({
        path: 'orderDetail',
        query: { order_sn: item.order_sn }
      });
    },
    // 申请开票
    applyBill() {
      if (!this.billInfo.ticket_type) {
        this.$message.warning('请选择开票类型！');
      } else if (!this.billInfo.ticket_real_type) {
        this.$message.warning('请选择发票类型！');
      } else if (!this.billInfo.ticket_head) {
        this.$message.warning('请输入纳税人抬头！');
      } else if (!this.billInfo.ticket_no) {
        this.$message.warning('请输入纳税人识别号！');
      } else {
        this.billInfo.order_sn = this.order_sn;
        api.applyBill(this.billInfo).then(res => {
          if (res.result) {
            this.$message.warning('操作成功！');
            this.getOrderList();
            this.dialogVisible = true;
          } else {
            this.$message.warning('订单暂时无法开取发票！');
          }
        });
      }
    },
    // 通用操作
    commonAction(type, item) {
      console.log(item);
      this.order_sn = item.order_sn;
      this.dialogText = type;
      this.dialogVisible = true;
    },
    // 确认确认收货
    confirmConfirm() {
      api.confirmRecevie({ order_sn: this.order_sn }).then(res => {
        if (res.result) {
          this.$message.warning('确认成功！');
          this.getOrderList();
          this.dialogVisible = false;
        } else {
          this.$message.warning('订单暂时无法确认收货！');
        }
      });
    },
    // 确认取消
    confirmCancelOrder() {
      if (!this.reason) {
        this.$message.warning('请选择取消原因！');
        return;
      }
      const params = {
        cancel_mark: this.reason,
        order_sn: this.order_sn
      };
      api.cancelOrder(params).then(res => {
        if (res.result) {
          this.$message.warning('取消成功！');
          this.getOrderList();
          this.dialogVisible = false;
        } else {
          this.$message.warning('取消失败！');
        }
      });
    },
    // 评价订单
    evaluateOrder(item) {
      console.log(item);
      this.$router.push({
        path: '/evaluateOrder',
        query: { order_sn: item.order_sn }
      });
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getOrderList();
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  padding: 32PX 30PX;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
  border-radius: 10PX;
}
.r-title {
  padding-bottom: 38PX;
  font-size: 20PX;
}
.type-tab-box {
  display: flex;
  border-bottom: 1PX solid #ececec;
  .type-list {
    padding-bottom: 12PX;
    margin-right: 50PX;
    font-size: 18PX;
    border-bottom: 2PX solid transparent;
    cursor: pointer;
    &:hover {
      color: #f1a373;
      border-bottom: 3PX solid #f1a373;
    }
  }
  .type-active {
    color: #f1a373;
    border-bottom: 3PX solid #f1a373;
  }
}
.course-box {
  padding: 46PX 0;
}
.course-list {
  padding: 14PX 25PX 26PX;
  margin-bottom: 24PX;
  background-color: #f8f8f8;
  border-radius: 6PX;
  cursor: pointer;
  .first-box {
    padding-bottom: 14PX;
    margin-bottom: 22PX;
    color: #777777;
    border-bottom: 1PX solid #e5e5e5;
    span {
      padding-left: 30PX;
    }
  }
  .type-text {
    float: right;
    color: #333333;
  }
  .no-start {
    color: #888888;
  }
  .y-text {
    color: #fb6d0a;
  }
  .second-box {
    display: flex;
  }
  .right-box {
    position: relative;
    flex: 1;
  }
  .c-img {
    width: 110PX;
    height: 110PX;
    margin-right: 10PX;
    background-color: #ffffff;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .c-title {
    padding-bottom: 12PX;
    font-size: 16PX;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .middle-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10PX;
  }
  .m-text {
    color: #999999;
    span {
      font-size: 16PX;
      color: #333333;
    }
  }
  .text-price {
    color: #999999;
    span {
      color: #333333;
    }
    .price {
      color: #dd0707;
      font-weight: bold;
      span {
        font-size: 22PX;
        color: #dd0707;
      }
    }
  }

  .btn-box {
    display: flex;
    flex-direction: row-reverse;
    .btn {
      padding: 0 14PX;
      margin-right: 16PX;
      font-size: 14PX;
      color: #8c8c8c;
      text-align: center;
      line-height: 32PX;
      border: 1PX solid #cecece;
      border-radius: 45PX;
      cursor: pointer;
    }
    .pay-btn {
      color: #ffffff;
      background-color: #f1a373;
      border: 1PX solid #f1a373;
    }
    .yellow-btn {
      color: #f1a373;
      line-height: 32PX;
      border: 1PX solid #f1a373;
    }
    .no-btn {
      color: #cecece;
      line-height: 32PX;
      border: 1PX solid #cecece;
    }
  }
  .contact-text {
    position: absolute;
    right: 0;
    bottom: 12PX;
    color: #666666;
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
  .el-dialog {
    padding: 0 20PX 0;
    border-radius: 9PX;
  }
  .el-input__inner {
    height: 36PX;
    line-height: 36PX;
  }
  .el-select {
    margin-left: 14PX;
  }
  .el-dialog__body {
    padding: 20PX 40PX;
  }
  .el-input {
    flex: 1;
    margin-left: 14PX;
  }
}
.dialog-title {
  padding-bottom: 40PX;
  font-size: 22PX;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
.select-box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30PX;
  .select-list {
    width: 40%;
    margin-bottom: 20PX;
  }
}
.select-list {
  margin-bottom: 14PX;
}
.dialog-btn-box {
  display: flex;
  justify-content: space-between;
  padding: 30PX 20PX;
  .btn {
    width: 44%;
    font-size: 18PX;
    color: #ffffff;
    line-height: 42PX;
    text-align: center;
    border-radius: 6PX;
    border: 1PX solid #f1a475;
    background-color: #f1a475;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .cancel {
    color: #666666;
    border-color: #979797;
    background-color: #ffffff;
  }
}
.confirm-button {
  width: 44%;
  margin: 0 auto 30PX;
  font-size: 18PX;
  color: #ffffff;
  line-height: 42PX;
  text-align: center;
  border-radius: 6PX;
  border: 1PX solid #f1a475;
  background-color: #f1a475;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.input-box {
  display: flex;
  margin-bottom: 20PX;
  > div {
    width: 100PX;
    color: #666666;
    text-align: right;
  }
}
.second-input {
  margin-bottom: 40PX;
}
.result-box {
  margin-bottom: 30PX;
  text-align: center;
  > div {
    font-size: 22PX;
    font-weight: 600;
  }
  .iconfont {
    padding-bottom: 40PX;
    font-size: 96PX;
    color: #52c41a;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/commodityOrder.vue